export default __webpack_public_path__ + "static/challenge-2628a683b7ddf019a4ad2acea0bc586a.jpg";